module.exports = __webpack_public_path__ + "media/images/illustration_5-6d748d8a5f18af62d65db014dbb78cdb.png";